import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import select from "./src/select.vue";
import option from "./src/option.vue";
import selectMore from "./src/select-more.vue";
import selectTree from "./src/select-tree.vue";
import selectSingleTree from "./src/select-single-tree.vue";
export const xSelect = withInstall(select, {
  option,
  selectMore,
  selectTree,
  selectSingleTree,
});
export default xSelect;
export const xOption = withNoopInstall(option);
export const xSelectMore = withNoopInstall(selectMore);
export const xSelectTree = withNoopInstall(selectTree);
export const xSelectSingleTree = withNoopInstall(selectSingleTree);
export * from "./src/select";
export * from "./src/select-more";
export * from "./src/select-tree";
export * from "./src/select-single-tree";
// TODO:图片没有数据的展示
// TODO:下拉项分组
